import { Button } from '@components/Buttons'
import { ReactPortal, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { ConfirmModalProps } from './interface'

export function ConfirmModal({
  isOpen,
  textConfirm = 'ยืนยัน',
  children,
  onConfirm,
}: ConfirmModalProps) {
  const [component, setComponent] = useState<ReactPortal | null>(null)

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : ''

    setComponent(
      isOpen
        ? createPortal(
            <div className='fixed right-0 left-0 top-0 bottom-0 bg-secondary-2 bg-opacity-30 flex justify-center items-center z-[100]'>
              <div className='py-[40px] w-[400px] flex flex-col items-center mobile:w-[348px] bg-white h-auto max-h-[90%] overflow-auto rounded-[10px] scrollbar-none'>
                {children}
                <div className='flex font-mitr text-secondary-1 justify-center items-center text-[14px]'>
                  <Button
                    className='text-white dark:text-white-2 bg-primary dark:bg-purple min-w-[109px] whitespace-nowrap'
                    type='button'
                    onClick={onConfirm}
                  >
                    {textConfirm}
                  </Button>
                </div>
              </div>
            </div>,
            document.body
          )
        : null
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  return component
}
